import InnerContainer from "@/components/ContentContainer/InnerContainer";
import Skeleton from "@/components/Skeleton/Skeleton";
import { useGetPackagingMaterial } from "../usePackagingMaterials";
import styles from "./PackagingMaterialDetail.module.scss";
import ProductRelationsPerYearTable from "./PackagingMaterialProductsPerYearTable";
import PackagingMaterialRelatedPackagingTable from "./PackagingMaterialRelatedPackagingTable";
import { Col, Row } from "antd";

export default function PackagingMaterialRelations({ materialId }: { materialId: number }) {
  const { data, isLoading } = useGetPackagingMaterial({ materialId });

  return (
    <InnerContainer
      title="Relations"
      borderTop={true}
      contentClassName={styles.MaterialRelations}
    >
      <Row gutter={[10, 10]}>
        <Col span={12}>
          <div className={[styles.relation, styles.products].join(" ")}>
            <div>
              <h3>Product packaging</h3>
              <span className={styles.metric}>
                <Skeleton
                  loading={isLoading}
                  style={{ width: 20, height: 24 }}
                >
                  {data?.packaging_relations}
                </Skeleton>
              </span>
            </div>
          </div>
        </Col>
        <Col span={12}>
          <div className={[styles.relation, styles.products].join(" ")}>
            <div>
              <h3>Facilities</h3>
              <span className={styles.metric}>
                <Skeleton
                  loading={isLoading}
                  style={{ width: 20, height: 24 }}
                >
                  {data?.facility_relations}
                </Skeleton>
              </span>
            </div>
          </div>
        </Col>
      </Row>

      <ProductRelationsPerYearTable materialId={materialId} />
      <PackagingMaterialRelatedPackagingTable materialId={materialId} />
    </InnerContainer>
  );
}
